import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import React, { ReactElement } from "react"

type Props<T> = {
    value: O.Option<T>
    children: (props: T) => ReactElement
}
function OptionalComponent<T>({ value, children }: Props<T>): ReactElement {
    return F.pipe(
        value,
        O.fold(
            () => <></>,
            (safeValue) => children(safeValue),
        ),
    )
}

export default OptionalComponent
